module.exports = __webpack_public_path__ + "media/images/metronic/social/picasa-b8361ae726f04a4f00e15f3ff6772fe9.png";